"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestUserInfo = http.create({baseURL:Config.BASE_API});

export default {
    //请求全体人员接口
    upload(params) {
        return RequestUserInfo.post('fastdfs/v1/upload', params, null, true)
    },
    //文件预览
    preview(params) {
        return RequestUserInfo.post('/fastdfs/v1/preview', params)
    },
}
